import { render, staticRenderFns } from "./CardTabItem.vue?vue&type=template&id=1dfef9e8&"
import script from "./CardTabItem.vue?vue&type=script&lang=js&"
export * from "./CardTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports